import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Comment } from 'api/conversations';
import { fullName } from 'utils/full-name';

interface TaskSpotlightedAuditLogsProps {
  comment: Comment;
}

export const TaskSpotlightedAddedMessage: React.FC<TaskSpotlightedAuditLogsProps> =
  ({ comment }) => {
    return (
      <FormattedMessage
        id="CONTROL_MESSAGE.TASK_SPOTLIGHT_ADDED"
        values={{
          changedByUserName: fullName(comment?.user),
        }}
      />
    );
  };

export const TaskSpotlightedRemovedMessage: React.FC<TaskSpotlightedAuditLogsProps> =
  ({ comment }) => {
    return (
      <FormattedMessage
        id="CONTROL_MESSAGE.TASK_SPOTLIGHT_REMOVED"
        values={{
          changedByUserName: fullName(comment?.user),
        }}
      />
    );
  };
